$(document).ready(function(){
    $('.testimonials-items').slick({
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 2.2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.2
          }
        }
      ]
    });

  if ($('.slick-activate').length) {
      $('.slick-activate').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
         autoplay: true,
      autoplaySpeed: 5000,
        arrows: true,
        dots: false,
       prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_35.svg?v=1751958627"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_34.svg?v=1751958627"></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }


  if ($('.logo-slider-activate').length) {
      $('.logo-slider-activate').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
         prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_35.svg?v=1751958627"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_34.svg?v=1751958627"></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
    }
  });

// featured product
document.addEventListener("DOMContentLoaded", function () {
    const mainImage = document.getElementById("mainProductImage");
    const thumbs = document.querySelectorAll(".thumbnail-items img");

    thumbs.forEach(thumb => {
      thumb.addEventListener("click", () => {
        // Update main image
        mainImage.src = thumb.dataset.full;

        // Remove active-border from all
        document.querySelectorAll('.thumbnail-items').forEach(item => {
          item.classList.remove('active-border');
        });

        // Add active-border to clicked one
        thumb.closest('.thumbnail-items').classList.add('active-border');
      });
    });
    if (thumbs.length > 0) {
      thumbs[0].closest('.thumbnail-items').classList.add('active-border');
    }

    $('.custom-thumbnail-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
       prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_35.svg?v=1751958627"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0267/1496/4061/files/Frame_34.svg?v=1751958627"></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
  });




document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 990) { 
        document.querySelectorAll('.product-card-wrapper').forEach(item => {
            
            const infoItem = item.querySelector('.product-card-wrapper .quick-add');
            const hoverInfo = item.querySelector('.product-card-wrapper .quick-add');

            item.addEventListener('mouseenter', () => {
                hoverInfo.style.maxHeight = `${hoverInfo.scrollHeight}px`;
                hoverInfo.style.opacity = "1";
                hoverInfo.style.visibility = "visible";

                infoItem.style.height = `${infoItem.scrollHeight + hoverInfo.scrollHeight}px`;
            });

            item.addEventListener('mouseleave', () => {
                hoverInfo.style.maxHeight = "0";
                hoverInfo.style.opacity = "0";
                hoverInfo.style.visibility = "hidden";

                infoItem.style.height = "auto";
            });
        });
    }
});



// card-image-text-progressbar
// var $slider = jQuery(".card-image-items");

// if ($slider.length) {
//   $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
//     var i = typeof currentSlide === "undefined" ? 0 : currentSlide + 1;
//     var calc = (i / slick.slideCount) * 100;
//     jQuery(".progress").css("background-size", calc + "% 100%");
//   });

//   $slider.slick({
//     dots: false,
//     autoplay: true,
//     pauseOnFocus: false,
//     pauseOnHover: false,
//     arrows: false,
//     cssEase: "linear",
//      autoplaySpeed: 5000,
//     variableWidth: true
    
//   });

//   // Trigger progress update on load
//   $slider.slick('slickGoTo', 0);
// }





// Product page custom variants code

$(document).ready(function () {
  function updateSections() {
    var selectedKit = $('input[name^="Kits"]:checked').data('optionn');

    // Step 2 Section 
    $('.step2_section').hide(); 
    $('.step2_section').filter(function () {
      return $(this).data('option') === selectedKit;
    }).first().show();

    // Top Section
    $('.top_section').hide().removeClass('top-section-active'); // Hide all and remove active class

    $('.top_section').filter(function () {
      return $(this).find('p[data-option]').data('option') === selectedKit;
    }).first().each(function () {
      $(this).show().addClass('top-section-active'); // Show and add active class
      $(this).find('.top_section_left, .top_section_right').removeAttr('style');
    });
  }

  // Initial run
  updateSections();

  // On Kit radio change
  $(document).on('change', 'input.option_name', function () {
    updateSections();
  });
});



// always choose last kit variant when click on anchor

 $('.step2_section a, .top_section a, .choose-last-kit a').click(function(e) {
    e.preventDefault();

    const lastInput = $('input[name^="Kits-1"]').last()[0]; 

    if (lastInput) {
      lastInput.checked = true;

      lastInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });



// redirect to correct id

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      const header = document.querySelector('header'); 
      const headerHeight = header ? header.offsetHeight : 0;

      // Adjust the scroll position
      const elementPosition = target.getBoundingClientRect().top + window.scrollY;
      const offset = 40; 
      const scrollTo = elementPosition - headerHeight - offset;

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });
    });
  });


// color label show
document.addEventListener("DOMContentLoaded", function () {
    const colorRadios = document.querySelectorAll('input[name="properties[Color Swatch]"]');
    const colorLabelOutput = document.querySelector('.metaobject-color-label');

    function updateColorLabel() {
      const selected = document.querySelector('input[name="properties[Color Swatch]"]:checked');
      if (selected && colorLabelOutput) {
        colorLabelOutput.textContent = selected.value;
      }
    }
    updateColorLabel();

    colorRadios.forEach(radio => {
      radio.addEventListener('change', updateColorLabel);
    });
  });



// popup redirect to kit color
// $(document).ready(function () {
//   $('.popup-btn').on('click', function (e) {
//     e.preventDefault();

     
//     const kitKey = $(this).attr('popupkit')?.trim().toLowerCase();
//     const colorKey = $(this).attr('popup-color')?.trim().toLowerCase();

//     let kitMatched = false;
//     let colorMatched = false;

//     // Match Kit
//     $('input.option_kits').each(function () {
//       const option = $(this).data('optionn')?.trim().toLowerCase();
//       if (option === kitKey) {
//         kitMatched = true;

//         if (!$(this).prop('checked')) {
//           $(this).click();
//         //  console.log(" Kit matched and clicked:", kitKey);
//         } else {
//          // console.log(" Kit already selected:", kitKey);
//         }

//         const label = $('label[for="' + $(this).attr('id') + '"]');
//         if (label.length) {
//           $('html, body').animate({
//             scrollTop: label.offset().top - 100
//           }, 600);          
//         //  console.log(" Scrolled to kit:", kitKey);
//         }
//       }
//     });

//     // Match Color
//     $('.color_section_swatches input[type="radio"]').each(function () {
//       const value = $(this).val()?.trim().toLowerCase();
//       if (value === colorKey) {
//         colorMatched = true;

//         if (!$(this).prop('checked')) {
//           $(this).click();
//           // console.log(" Color matched and clicked:", colorKey);
//         } else {
//          // console.log(" Color already selected:", colorKey);
//         }

//         const label = $('label[for="' + $(this).attr('id') + '"]');
//         if (label.length) {
//           $('html, body').animate({
//             scrollTop: label.offset().top - 100
//           }, 600);
//          // console.log(" Scrolled to color swatch:", colorKey);
//         }
//       }
//     });

//     // Final result
//     if (kitMatched && colorMatched) {
//      // console.log(" Matched and redirected to kit and color:", kitKey, colorKey);
//       $('#story-popup-modal').hide(); 
//       $('body').removeClass('overflow-hidden');
//     } else {
//       // if (!kitMatched) console.warn(" Kit not matched:", kitKey);
//       // if (!colorMatched) console.warn("Color not matched:", colorKey);
//     }
//   });
// });

$(document).ready(function () {

  const normalize = (v) => (v || '').toString().trim().toLowerCase();
  const getSelectedKit = () => normalize($('input.option_kits:checked').data('optionn'));

  function toggleLockBtns() {
    const selectedKit = getSelectedKit();

    if (selectedKit === 'the-all-day-system') {
      // If "the-all-day-system" selected, show ALL unlocked, hide ALL locked
      $('.btn-unlocked').show();
      $('.btn-locked').hide();
    } else {
      //  Else match per block (popupkit or sliderkit)
      $('.story-model-innerbar-right, .story-slides-btn').each(function () {
        const $ctx = $(this);
        const $keyEl = $ctx.find('[popupkit],[sliderkit]').first();
        if (!$keyEl.length) return;

        const kitKey = normalize($keyEl.attr('popupkit') || $keyEl.attr('sliderkit'));
        const isMatch = selectedKit && kitKey === selectedKit;

        $ctx.find('.btn-unlocked')[isMatch ? 'show' : 'hide']();
        $ctx.find('.btn-locked')[isMatch ? 'hide' : 'show']();
      });
    }
  }

  toggleLockBtns();

  $(document).on('change', 'input.option_kits', function () {
    toggleLockBtns();
  });

  $(document).on('click', '.popup-btn', function (e) {
    e.preventDefault();

    const kitKey = normalize($(this).attr('popupkit'));
    const colorKey = normalize($(this).attr('popup-color'));

    let kitMatched = false;
    let colorMatched = false;

    $('input.option_kits').each(function () {
      const option = normalize($(this).data('optionn'));
      if (option === kitKey) {
        kitMatched = true;

        if (!$(this).prop('checked')) {
          $(this).click();
        }

        const label = $('label[for="' + $(this).attr('id') + '"]');
        if (label.length) {
          $('html, body').animate({
            scrollTop: label.offset().top - 100
          }, 600);
        }
      }
    });

    $('.color_section_swatches input[type="radio"]').each(function () {
      const value = normalize($(this).val());
      if (value === colorKey) {
        colorMatched = true;

        if (!$(this).prop('checked')) {
          $(this).click();
        }

        const label = $('label[for="' + $(this).attr('id') + '"]');
        if (label.length) {
          $('html, body').animate({
            scrollTop: label.offset().top - 100
          }, 600);
        }
      }
    });

    if (kitMatched && colorMatched) {
      $('#story-popup-modal').hide();
      $('body').removeClass('overflow-hidden');

      //  Re-check and update button visibility
      toggleLockBtns();
    }
  });
});




// red more read less on color line item description
document.addEventListener("DOMContentLoaded", function () {
  const textContainers = document.querySelectorAll(".read-more-text");

  textContainers.forEach(container => {
    const fullText = container.dataset.text;
    const words = fullText.split(" ");
    const first20 = words.slice(0, 20).join(" ");
    const remaining = words.slice(20).join(" ");

    if (words.length <= 20) {
      container.textContent = fullText;
      return;
    }

    const span = document.createElement("span");
    span.innerHTML = `${first20}<span class="dots">... </span><span class="more" style="display:none;">${remaining}</span>`;

    const toggle = document.createElement("span");
    toggle.className = "read-more-toggle";
    toggle.innerHTML = `Read more <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>`;

    toggle.addEventListener("click", () => {
      const more = span.querySelector(".more");
      const dots = span.querySelector(".dots");
      const isExpanded = more.style.display === "inline";

      more.style.display = isExpanded ? "none" : "inline";
      dots.style.display = isExpanded ? "inline" : "none";
      toggle.innerHTML = isExpanded
        ? `Read more <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>`
        : `Read less <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 15l-7-7-7 7" /></svg>`;
    });

    container.innerHTML = "";
    container.appendChild(span);
    container.appendChild(toggle);
  });
});



// // show images according to colors
//  document.addEventListener("DOMContentLoaded", function () {
//     const radios = document.querySelectorAll('.color_section_swatches input[type="radio"]');

//     function matchRadioToImage(radio) {
//       const selectedValue = radio.value.trim().toLowerCase();
//       let matchFound = false;

//       const thumbnails = document.querySelectorAll('.thumbnail-list__item');

//       thumbnails.forEach(function (item) {
//         const img = item.querySelector('img');
//         const altText = img?.getAttribute('alt')?.trim().toLowerCase();

//         if (altText === selectedValue) {
//           matchFound = true;
//           item.classList.add("color-image-matched");
//         } else {
//           item.classList.remove("color-image-matched");
//         }
//       });

//       if (!matchFound) {
//         //console.log(" No match found for value:", selectedValue);
//         return;
//       }

//       //  Auto-trigger first matched thumbnail
//       const firstMatched = document.querySelector('.thumbnail-list__item.color-image-matched');
//       if (firstMatched) {
//         const clickable = firstMatched.querySelector('a, button, img');
//         if (clickable) {
//           clickable.click();
//           //console.log(" Auto-triggered:", clickable);
//         }
//       }
//     }

//     // Page load
//     radios.forEach(function (radio) {
//       if (radio.checked) {
//         matchRadioToImage(radio);
//       }
//     });

//     // On click
//     radios.forEach(function (radio) {
//       radio.addEventListener("click", function () {
//         matchRadioToImage(radio);
//       });
//     });
//   });

document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('.color_section_swatches input[type="radio"]');

  function matchRadioToImage(radio) {
    const selectedValue = radio.value.trim().toLowerCase();
    let matchFound = false;

    const thumbnails = document.querySelectorAll('.thumbnail-list__item');

    thumbnails.forEach(function (item) {
      const img = item.querySelector('img');
      const altText = img?.getAttribute('alt')?.trim().toLowerCase();

      if (altText === selectedValue) {
        matchFound = true;
        item.classList.add("color-image-matched");
      } else {
        item.classList.remove("color-image-matched");
      }
    });

    if (!matchFound) return;

    // ===== NEW PART =====
    // Hide unmatched product__media-item on mobile
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    if (isMobile) {
      const mediaItems = document.querySelectorAll('.product__media-item');
      mediaItems.forEach(item => {
        const img = item.querySelector('img');
        const altText = img?.getAttribute('alt')?.trim().toLowerCase();
        if (altText === selectedValue) {
          item.style.display = "";
        } else {
          item.style.display = "none";
        }
      });
    }
    // ===== END NEW PART =====

    // Auto-trigger first matched thumbnail
    const firstMatched = document.querySelector('.thumbnail-list__item.color-image-matched');
    if (firstMatched) {
      const clickable = firstMatched.querySelector('a, button, img');
      if (clickable) {
        clickable.click();
      }
    }
  }

  // Page load
  radios.forEach(function (radio) {
    if (radio.checked) {
      matchRadioToImage(radio);
    }
  });

  // On click
  radios.forEach(function (radio) {
    radio.addEventListener("click", function () {
      matchRadioToImage(radio);
    });
  });
});




// multi product backgeound button trigger
document.addEventListener('click', function (e) {
  if (e.target.classList.contains('kit-target-last')) {
    e.preventDefault(); 

    const kitValue = e.target.getAttribute('data-kit');
   // console.log('Clicked .kit-target-last with data-kit:', kitValue);

    let foundMatch = false;

    document.querySelectorAll('input.option_kits').forEach(function (radio) {
      const optionValue = radio.getAttribute('data-optionn');

      if (optionValue === kitValue) {
        //console.log(' Match found! Clicking radio and scrolling to it:', optionValue);
        radio.click();
        radio.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        foundMatch = true;
      }
    });

    if (!foundMatch) {
      //console.warn(' No matching radio found for data-kit:', kitValue);
    }
  }
});

// add class pdp tabs section style for mobile
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".scroll-tab");

  function activateTab(tab) {
    const targetId = tab.getAttribute("data-target");
    tabs.forEach(t => t.classList.remove("custom-scroll-tab"));
    tab.classList.add("custom-scroll-tab");

    document.querySelectorAll(".video-section").forEach(section => {
      section.classList.remove("custom-scroll-tab");
    });

    // Add class to target video section
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      targetSection.classList.add("custom-scroll-tab");
    }
  }

  // On page load: activate the currently active tab
  const activeTab = document.querySelector(".scroll-tab.active");
  if (activeTab) {
    activateTab(activeTab);
  }
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      activateTab(tab);
    });
  });
});




